<template>
	<!-- <footer>
		 <div class="footer_container">
			<p class="copyright">ⓒ {{ $t('rtr_footer.text1') }}</p>
			<div v-if="0" class="footer_link">
				<ul>
					<li><router-link to @click="notYet">About</router-link></li>
					<li><router-link :to="{ name: 'terms' }">Privacy</router-link></li>
					<li><router-link :to="{ name: 'cookies' }">Cookies</router-link></li>
				</ul>
			</div>
		</div>
	</footer> -->
	<footer class="footer_sec">
		<div class="footer_up">
			<div class="container">
				<div class="row">
					<div class="col-sm-3">
						<div class="footer_inn">
							<img
								style="width: 200px"
								:src="img.image26"
								:alt="
									$t(
										'new_ui.components.footer_component.accessibility.logo_alt',
									)
								"
							/>

							<div class="footer_lt">
								<h6>
									{{ $t('new_ui.components.footer_component.connect.title') }}
								</h6>

								<p>
									<img
										:src="img.image29"
										:alt="
											$t('new_ui.components.footer_component.connect.email.alt')
										"
									/>
									<a href="mailto:support@jpworldpay.com">{{
										$t(
											'new_ui.components.footer_component.connect.email.support',
										)
									}}</a>
								</p>
								<p>
									<img
										:src="img.image30"
										:alt="
											$t('new_ui.components.footer_component.connect.email.alt')
										"
									/>
									<a href="mailto:support@jpworldpay.com">{{
										$t('new_ui.components.footer_component.connect.email.info')
									}}</a>
								</p>
							</div>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="footer2">
							<h6>
								{{
									$t(
										'new_ui.components.footer_component.navigation.individual.title',
									)
								}}
							</h6>
							<ul>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/online_shopping',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.online_shopping',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/offline_kiosk',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.offline_kiosk',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/qr',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.pay_with_qr',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/how/trade_and_cashback',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.transaction_cashback',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/send',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.send_asset',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/receive',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.asset_request',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/deposit',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.get_deposit',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/request/commission',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.fee',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/wallet',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.wallet',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/account',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.account',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/sale',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.sell',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/exchange',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.individual.menu_items.exchanging_currency',
											)
										}}</a
									>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="footer2">
							<h6>
								{{
									$t(
										'new_ui.components.footer_component.navigation.business.title',
									)
								}}
							</h6>
							<ul>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/start',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.business.menu_items.getting_started',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/receive',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.business.menu_items.accepting_payment',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/pay',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.business.menu_items.make_payment',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/how/risk',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.business.menu_items.risk_management',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/corps',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.business.menu_items.about_company',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/platform',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.business.menu_items.platforms_features',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/pay',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.business.menu_items.payment_method',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/operation/global',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.business.menu_items.global_payment',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/business/pay',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.business.menu_items.global_processing',
											)
										}}</a
									>
								</li>
							</ul>
						</div>
					</div>
					<div class="col-sm-3">
						<div class="footer2">
							<h6>
								{{
									$t(
										'new_ui.components.footer_component.navigation.other_links.title',
									)
								}}
							</h6>
							<ul>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/personal/asset/jpys',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.other_links.menu_items.about',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/development/main',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.other_links.menu_items.development',
											)
										}}</a
									>
								</li>
								<li>
									<a v-if="0" href="">{{
										$t(
											'new_ui.components.footer_component.navigation.other_links.menu_items.customer_service',
										)
									}}</a>
								</li>
								<li>
									<a v-if="0" href="">{{
										$t(
											'new_ui.components.footer_component.navigation.other_links.menu_items.testimonial',
										)
									}}</a>
								</li>
								<li>
									<a v-if="0" href="">{{
										$t(
											'new_ui.components.footer_component.navigation.other_links.menu_items.contact',
										)
									}}</a>
								</li>
							</ul>
						</div>

						<div class="footer2 footer3">
							<h6>
								{{
									$t(
										'new_ui.components.footer_component.navigation.terms_policy.title',
									)
								}}
							</h6>
							<ul>
								<li v-if="0">
									<a href="">{{
										$t(
											'new_ui.components.footer_component.navigation.terms_policy.menu_items.privacy',
										)
									}}</a>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/cookies',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.terms_policy.menu_items.cookies',
											)
										}}</a
									>
								</li>
								<li>
									<a
										class="dropdown-item"
										href="javascript:void(0)"
										v-on:click="
											$router.push({
												path: '/terms/terms/franchise_agreement',
											})
										"
										>{{
											$t(
												'new_ui.components.footer_component.navigation.terms_policy.menu_items.terms',
											)
										}}</a
									>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mob_footer">
			<div class="accordion" id="accordionExample">
				<div class="accordion-item">
					<h2 class="accordion-header" id="headingOne">
						<button
							class="accordion-button"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseOne"
							aria-expanded="true"
							aria-controls="collapseOne"
						>
							<img :src="img.image26" alt="" />
						</button>
					</h2>
					<div
						id="collapseOne"
						class="accordion-collapse collapse show"
						aria-labelledby="headingOne"
						data-bs-parent="#accordionExample"
					>
						<div class="accordion-body">
							<div class="container">
								<div class="row">
									<div class="col-sm-3">
										<div class="footer_inn">
											<div class="footer_lt">
												<h6>
													{{
														$t(
															'new_ui.components.footer_component.footermob.main_head',
														)
													}}
												</h6>

												<p>
													<img :src="img.image29" alt="" />
													<a href="mailto:support@jpworldpay.com">{{
														$t(
															'new_ui.components.footer_component.footermob.mail1',
														)
													}}</a>
												</p>
												<p>
													<img :src="img.image30" alt="" />
													<a href="mailto:support@jpworldpay.com">{{
														$t(
															'new_ui.components.footer_component.footermob.mail2',
														)
													}}</a>
												</p>
											</div>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="footer2">
											<h6>
												{{
													$t(
														'new_ui.components.footer_component.footermob.individual.title',
													)
												}}
											</h6>
											<ul>
												<li>
													<a
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/how/online_shopping',
															})
														"
														>{{
															$t(
																'new_ui.components.footer_component.footermob.individual.list1',
															)
														}}</a
													>
												</li>
												<li>
													<a
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/how/offline_kiosk',
															})
														"
														>{{
															$t(
																'new_ui.components.footer_component.footermob.individual.list2',
															)
														}}</a
													>
												</li>
												<li>
													<a
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/how/qr',
															})
														"
														>{{
															$t(
																'new_ui.components.footer_component.footermob.individual.list3',
															)
														}}</a
													>
												</li>
												<li>
													<a
														href="javascript:void(0)"
														v-on:click="
															$router.push({
																path: '/personal/how/trade_and_cashback',
															})
														"
														>{{
															$t(
																'new_ui.components.footer_component.footermob.individual.list4',
															)
														}}</a
													>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.individual.list5',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.individual.list6',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.individual.list7',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.individual.list8',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.individual.list9',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.individual.list10',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.individual.list11',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.individual.list12',
														)
													}}</a>
												</li>
											</ul>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="footer2">
											<h6>
												{{
													$t(
														'new_ui.components.footer_component.footermob.business.title',
													)
												}}
											</h6>
											<ul>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.business.list1',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.business.list2',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.business.list3',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.business.list4',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.business.list5',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.business.list6',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.business.list7',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.business.list8',
														)
													}}</a>
												</li>
											</ul>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="footer2">
											<h6>
												{{
													$t(
														'new_ui.components.footer_component.footermob.OtherLinks.title',
													)
												}}
											</h6>
											<ul>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.OtherLinks.list1',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.OtherLinks.list2',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.OtherLinks.list3',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.OtherLinks.list4',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.OtherLinks.list5',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.OtherLinks.list6',
														)
													}}</a>
												</li>
											</ul>
										</div>

										<div class="footer2 footer3">
											<h6>
												{{
													$t(
														'new_ui.components.footer_component.footermob.terms.title',
													)
												}}
											</h6>
											<ul>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.terms.list1',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.terms.list2',
														)
													}}</a>
												</li>
												<li>
													<a href="">{{
														$t(
															'new_ui.components.footer_component.footermob.terms.list3',
														)
													}}</a>
												</li>
											</ul>
										</div>
										<div class=""></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer_dwn">
			<div class="container">
				<div class="row">
					<div class="col-sm-12">
						<p>{{ $t('new_ui.components.footer_component.copyright.text') }}</p>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import footerlogo from '@/assets/images/sub/footerlogo_white.png';
import phncall from '@/assets/images/sub/Call.png';
import whtsp from '@/assets/images/sub/WhatsApp.png';
import mail from '@/assets/images/sub/Mail.png';

export default {
	data: () => ({
		img: {
			image26: footerlogo,
			image27: phncall,
			image28: whtsp,
			image29: mail,
			image30: mail,
		},
	}),

	name: 'Footer',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>
